import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchBox from '../Parts/SearchBox';
import { UserSearchWrapper } from '../Operator/styles/OperatorPageStyles';
import CallHistoryLists from './CallHistoryLists';
import getCallHistories from '../../actions/api/remoteSupport/getCallHistories';

const CollHistoryComponent = () => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const [operatorName, setOperatorName] = useState('');

  useEffect(() => {
    dispatch(getCallHistories(apiToken, targetGroupId, operatorName));
  }, [apiToken, dispatch, targetGroupId, operatorName]);

  const handleSearchChange = e => {
    setOperatorName(e.target.value);
  };

  return (
    <Fragment key="operator-content-call-history">
      <UserSearchWrapper>
        <SearchBox defaultValue={operatorName} onChange={handleSearchChange} />
      </UserSearchWrapper>
      <CallHistoryLists />
    </Fragment>
  );
};

export default CollHistoryComponent;
